import { PersianTitlesService } from '../../core/services/persian-titles.service';

export const navbarItems = (persianTitlesService: PersianTitlesService) => [
  {
    id: '0',
    name: persianTitlesService.Items.HomePage,
    urlParts: ['/'],
  },
  {
    id: '5',
    name: persianTitlesService.Items.Workshops,
    items: [
      {
        id: 'workshops',
        name: persianTitlesService.Items.CurrentWorkshops,
        urlParts: ['workshop', 'workshops'],
      },
      {
        id: 'held-workshops',
        name: persianTitlesService.Items.HeldWorkshops,
        urlParts: ['held-workshop', 'held-workshops'],
      },
    ],
  },
  {
    id: '4',
    name: persianTitlesService.Items.WorkshopsVideo,
    urlParts: ['e-workshop', 'e-workshops'],
  },
  {
    id: '2',
    name: persianTitlesService.Items.MyUserInformation,
    urlParts: ['profile', 'edit'],
  },
  {
    id: '3',
    name: persianTitlesService.Items.MyTrainingHistory,
    urlParts: ['profile', 'my-training-history'],
  },
  {
    id: 'feedback',
    name: persianTitlesService.Items.SuggestionsAndCriticisms,
    urlParts: ['feedback'],
  },
];
